'use client';

import { useQuery } from '@tanstack/react-query';
import { getSalesAgentCalendar } from 'services/user';
import { resolveGoldMeetingUrl } from 'utils/goldCampaign';

const useGoldMeetingUrl = (enabled: boolean): string | null => {
  const { data, isFetched } = useQuery({
    queryKey: ['salesAgentCalendar'],
    queryFn: getSalesAgentCalendar,
    enabled,
    retry: 2,
    retryDelay: 1000,
    staleTime: 5 * 60 * 1000,
    refetchOnWindowFocus: false,
  });
  if (!enabled || !isFetched) return null;
  return resolveGoldMeetingUrl(data);
};

export default useGoldMeetingUrl;
